<div style="100%; position: relative;">
  <div style="line-height: 1rem; position: relative; font-weight: bold; float: left; text-align: right;">
    {{property}}
  </div>
  <div style="line-height: 1rem; position: relative; width: 45%; float: left; text-align: left;">
    <span style="position: absolute; bottom: -10px;">
      @if (allowSorting) {
        <button (click)="sort(sortDirections.Ascending)">
          <svg-icon icon="icon-caret-up" class="small black"></svg-icon>
        </button>
      }
    </span>
    <span style="position: absolute; top: 5px;">
      @if (allowSorting) {
        <button (click)="sort(sortDirections.Descending)">
          <svg-icon icon="icon-caret-down" class="small black"></svg-icon>
        </button>
      }
    </span>
  </div>
  <div style="clear: both;">&nbsp;</div>
</div>
